export function uuidv4() {
    let base = ''+1e7+-1e3+-4e3+-8e3+-1e11;
    return base.replace(/[018]/g, (c: any) =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
 
        );
}

export function getQueryParams(url?) {
    if(!url){
        url = window.location.href;
    }
    const paramArr = url.slice(url.indexOf('?') + 1).split('&');
    const params = {};
    paramArr.map(param => {
        const [key, val] = param.split('=');
        params[key] = decodeURIComponent(val);
    })
    return params;
}

/** Legge un claim dal payload del JWT (senza validarlo: serve solo per la UI). */
export function getTokenClaim(token: string, claim: string): string {
    if(!token)
        return "";
    try {
        let payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        let bytes = Uint8Array.from(atob(payload), c => c.charCodeAt(0));
        let json = JSON.parse(new TextDecoder().decode(bytes));
        return json[claim] || "";
    } catch {
        return "";
    }
}
